import { injectable } from 'inversify';

import type { FlowTreeNode } from '@vk-hr-tek/ui/FlowTree';

@injectable()
export class SettingsWorkflowTreeMapper {
  processFlattenFlowTreeNodes(node: FlowTreeNode | null): FlowTreeNode[] {
    if (!node) {
      return [];
    }

    const nodes: FlowTreeNode[] = [node];

    if (node.children) {
      node.children.forEach((child) => {
        nodes.push(...this.processFlattenFlowTreeNodes(child));
      });
    }

    if (node.managerBlockNode) {
      nodes.push(...this.processFlattenFlowTreeNodes(node.managerBlockNode));
    }

    if (node.constrictOf) {
      node.constrictOf.forEach((child) => {
        nodes.push(...this.processFlattenFlowTreeNodes(child));
      });
    }

    return nodes;
  }

  processUpdateFlowTreeData(
    tree: FlowTreeNode | null,
    id: string | null,
    errors: string[],
    changed: string[],
    managerBlockStatus?: 'active' | 'updated' | 'default',
  ) {
    const updateNode = (node: FlowTreeNode): FlowTreeNode => {
      let newNode = { ...node };
      const getStatus = () => {
        if (errors.includes(node.id)) return 'error';
        if (changed.includes(node.id)) return 'changed';

        return 'default';
      };

      newNode = {
        ...newNode,
        activeNode: !managerBlockStatus && node.id === id,
        activeManagerNode: !!managerBlockStatus && node.id === id,
        ...(!managerBlockStatus && { editStatus: getStatus() }),
        ...(id &&
          newNode.managerBlocksLinks?.includes(id) && {
            managerBlockStatus:
              newNode.managerBlockStatus === 'updated' ||
              managerBlockStatus === 'updated'
                ? 'updated'
                : 'default',
          }),
      };

      if (node.children?.length) {
        newNode = {
          ...newNode,
          children: node.children.map(updateNode),
        };
      }

      if (node.managerBlockNode) {
        newNode = {
          ...newNode,
          managerBlockNode: updateNode(node.managerBlockNode),
        };
      }

      if (node.constrictOf) {
        newNode = {
          ...newNode,
          constrictOf: node.constrictOf.map(updateNode),
        };
      }

      return newNode;
    };

    if (!tree || !id) {
      return null;
    }

    return updateNode(tree);
  }
}
